import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-localized-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule, SelectModule, TranslateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocalizedDropdownComponent),
      multi: true,
    },
  ],
  templateUrl: './localized-dropdown.component.html',
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
    `,
  ],
})
export class LocalizedDropdownComponent implements ControlValueAccessor {
  @Input() options: any[] = [];
  @Input() placeholder: string = '';
  @Input() showClear: boolean = false;
  @Input() optionLabel: string = 'label';
  @Input() optionValue: string = 'value';
  @Input() styleClass: string = '';
  @Input() appendTo: any = null;

  @Output() onChange = new EventEmitter<any>();

  value: any = null;
  isDisabled: boolean = false;

  onChangeFn = (_: any) => {};
  onTouchedFn = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onDropdownChange(event: any): void {
    this.value = event.value;
    this.onChangeFn(this.value);
    this.onChange.emit(event);
  }
}
